import { IBrief } from "../../briefs";
import { EntityTypes } from "../../EntityTypes";
import { IMissionResource } from "../../missions";
import { IUserResource } from "../../users";
import { createApiMutationHook, type IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, type RelationalValue } from "../../utils/filters";
import type { IFollowUp } from "../types/IFollowUp";

export interface IFollowUpUpdateMutationParameters {
    followUp: RelationalValue<IFollowUp>;
    learner: RelationalValue<IUserResource>;
    briefs?: RelationalValue<IBrief>[];
    progression?: string;
    autonomy?: string;
    strength?: string;
    improvement?: string;
    more?: string;
    periodStart: string;
    periodEnd: string;
    periodType?: string[];
    waypoint: string;
    title: string;
    missions?: RelationalValue<IMissionResource>[];
}

export type IFollowUpUpdateMutationResult = IFollowUp;

export const followUpUpdateMutation: IApiMutationFunction<IFollowUpUpdateMutationParameters> = data => ({
    method: "PUT",
    url: `/follow_ups/${mapRelationalValue(data.followUp)}`,
    data: {
        learner: mapRelationalValueAsIRI(EntityTypes.USER, data.learner),
        briefs: data?.briefs?.map(brief => mapRelationalValueAsIRI(EntityTypes.BRIEF, brief)),
        missions: data?.missions?.map(mission => mapRelationalValueAsIRI(EntityTypes.MISSION, mission)),
        progression: data.progression,
        autonomy: data.autonomy,
        strength: data.strength,
        improvement: data.improvement,
        more: data.more,
        periodStart: data.periodStart,
        periodEnd: data.periodEnd,
        periodType: data.periodType,
        waypoint: data.waypoint,
        title: data.title,
    },
});

export const useFollowUpUpdateMutation = createApiMutationHook<
    IFollowUpUpdateMutationParameters,
    IFollowUpUpdateMutationResult
>(followUpUpdateMutation);
